module.exports = __webpack_public_path__ + "static/media/pic_flo.ad542921.png";